module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"searchPlaceholder":"Encontrar páginas"},"en":{"searchPlaceholder":"Find pages"}}')
  delete Component.options._Ctor
}
